import { createContext, useState, useEffect } from "react";

// Create context
export const CurrencyContext = createContext();

const CurrencyContextProvider = ({ children }) => {
  const [currency, setCurrency] = useState("USD");
  const [loading, setLoading] = useState(true);
  const exchangeRate = 84 * 0.4; // Current USD to INR exchange rate

  useEffect(() => {
    const getUserLocation = async () => {
      try {
        // First try to get location from IP
        const ipResponse = await fetch('https://ipapi.co/json/');
        const ipData = await ipResponse.json();

        if (ipData.country_code === 'IN') {
          console.log('Detected India from IP:', ipData);
          setCurrency("INR");
          setLoading(false);
          return;
        }

        // If IP detection fails, try geolocation
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              console.log('Geolocation coordinates:', { latitude, longitude });
              determineCurrency(latitude, longitude);
            },
            (error) => {
              console.error("Geolocation error:", error);
              // Default to INR for any error
              setCurrency("INR");
              setLoading(false);
            }
          );
        } else {
          console.warn("Geolocation not supported");
          // Default to INR if geolocation not supported
          setCurrency("INR");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error in location detection:", error);
        // Default to INR on any error
        setCurrency("INR");
        setLoading(false);
      }
    };

    const determineCurrency = (lat, lon) => {
      console.log('Determining currency for coordinates:', { lat, lon });
      // India's approximate coordinates
      if (lat >= 8 && lat <= 37 && lon >= 68 && lon <= 97) {
        setCurrency("INR"); // India
      } else {
        console.log('Setting currency to USD');
        setCurrency("USD");
      }
      setLoading(false);
    };

    getUserLocation();
  }, []);

  // Helper to round up to nearest 9
  function roundUpToNearest9(num) {
    num = Math.ceil(Number(num));
    if (num % 10 === 9) return num;
    return num + (9 - (num % 10));
  }

  const formatPrice = (price) => {
    if (!currency) return null;

    let convertedPrice = price;
    if (currency === "INR") {
      convertedPrice = price * exchangeRate;
      convertedPrice = roundUpToNearest9(convertedPrice);
    }
    return new Intl.NumberFormat(currency === "INR" ? "en-IN" : "en-US", {
      style: "currency",
      currency: currency,
      maximumFractionDigits: 0
    }).format(convertedPrice);
  };

  return (
    <CurrencyContext.Provider value={{ currency, formatPrice, loading }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyContextProvider;
